<script setup lang="ts">
import { useI18n } from '../composables/I18n';

const { t } = useI18n();
</script>

<template>
	<div class="spinner-border" role="status">
		<span class="visually-hidden">{{ t('common.loading') }}</span>
	</div>
</template>

<style scoped>

</style>
